import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "timeseries-trigger",
    attrs: {
      "data-cy": "timeseries_trigger"
    }
  }, [_c('p', {
    staticClass: "card-description mt-0",
    domProps: {
      "innerHTML": _vm._s(_vm.descriptionHtml)
    }
  }), _c('core-n20Card', {
    staticClass: "dt-card-text-01 mt-0",
    attrs: {
      "data-cy": "trigger_on_update_card"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c(VCol, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.t('onStateUpdate')))]), _c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n          " + _vm._s(_vm.trigger.onStateUpdate ? _vm.t('onStateUpdateOnText') : _vm.t('onStateUpdateOffText')) + "\n        ")])]), _c(VCol, {
    staticClass: "pl-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c(VSwitch, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "color": _vm.color,
      "disabled": _vm.readonly,
      "inset": "",
      "hide-details": "",
      "data-cy": "trigger_on_update_switch"
    },
    model: {
      value: _vm.trigger.onStateUpdate,
      callback: function ($$v) {
        _vm.$set(_vm.trigger, "onStateUpdate", $$v);
      },
      expression: "trigger.onStateUpdate"
    }
  })], 1)], 1)], 1), _c('core-n20Card', {
    staticClass: "dt-card-text-01 mt-6",
    attrs: {
      "data-cy": "trigger_schedule_card"
    }
  }, [_c(VRow, {
    staticClass: "mb-2",
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c(VCol, [_c('div', {
    staticClass: "text-bold"
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-clock")]), _vm._v("\n          " + _vm._s(_vm.t('schedule')) + "\n        ")], 1)]), _vm.schedule && !_vm.readonly ? _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VBtn, {
    attrs: {
      "text": "",
      "small": "",
      "color": "error",
      "data-cy": "trigger_remove_schedule"
    },
    on: {
      "click": _vm.removeSchedule
    }
  }, [_c(VIcon, {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("fal fa-trash-alt")]), _vm._v("\n          " + _vm._s(_vm.t('removeSchedule')) + "\n        ")], 1)], 1) : _vm._e()], 1), !_vm.schedule ? [_c('p', {
    staticClass: "card-description"
  }, [_vm._v(_vm._s(_vm.t('noSchedule')))]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.readonly,
      "prepend-icon": "fa-clock",
      "data-cy": "trigger_add_schedule"
    },
    on: {
      "click": _vm.addSchedule
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('addSchedule')) + "\n      ")])] : [_c('div', {
    staticClass: "trigger-field-label"
  }, [_vm._v(_vm._s(_vm.t('howOften')))]), _c('div', {
    staticClass: "trigger-repeat mb-4",
    attrs: {
      "data-cy": "trigger_repeat"
    }
  }, _vm._l(_vm.repeats, function (repeat) {
    return _c(VBtn, {
      key: repeat,
      class: ['text-none', {
        'trigger-repeat__active': _vm.schedule.repeat === repeat
      }],
      attrs: {
        "color": _vm.schedule.repeat === repeat ? _vm.color : undefined,
        "dark": _vm.schedule.repeat === repeat && !_vm.readonly,
        "outlined": _vm.schedule.repeat !== repeat,
        "disabled": _vm.readonly,
        "data-cy": `trigger_repeat_${repeat}`,
        "depressed": "",
        "large": ""
      },
      on: {
        "click": function ($event) {
          return _vm.setRepeat(repeat);
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.t(`repeat.${repeat}`)) + "\n        ")]);
  }), 1), _c(VRow, [_vm.isHourly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.minuteOptions,
      "label": _vm.t('startingAtMinute'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.readonly,
      "hide-details": "",
      "data-cy": "trigger_minute"
    },
    model: {
      value: _vm.schedule.minute,
      callback: function ($$v) {
        _vm.$set(_vm.schedule, "minute", $$v);
      },
      expression: "schedule.minute"
    }
  })], 1) : _vm._e(), _vm.isWeekly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.weekDayOptions,
      "label": _vm.t('on'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.readonly,
      "hide-details": "",
      "data-cy": "trigger_week_day"
    },
    model: {
      value: _vm.schedule.weekDay,
      callback: function ($$v) {
        _vm.$set(_vm.schedule, "weekDay", $$v);
      },
      expression: "schedule.weekDay"
    }
  })], 1) : _vm._e(), _vm.isMonthly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.monthDayOptions,
      "label": _vm.t('on'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.readonly,
      "hide-details": "",
      "data-cy": "trigger_month_day"
    },
    model: {
      value: _vm.schedule.monthDay,
      callback: function ($$v) {
        _vm.$set(_vm.schedule, "monthDay", $$v);
      },
      expression: "schedule.monthDay"
    }
  })], 1) : _vm._e(), !_vm.isHourly ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": _vm.timeString,
      "label": _vm.t('at'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.readonly,
      "rules": _vm.timeRules,
      "type": "time",
      "append-icon": "fal fa-clock",
      "hide-details": "auto",
      "data-cy": "trigger_time"
    },
    on: {
      "input": _vm.setTime
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('core-timezone-selector', {
    attrs: {
      "label": _vm.t('timeZone'),
      "rules": _vm.requiredRule,
      "mode": _vm.mode,
      "required": "",
      "data-cy": "trigger_time_zone"
    },
    model: {
      value: _vm.schedule.timeZone,
      callback: function ($$v) {
        _vm.$set(_vm.schedule, "timeZone", $$v);
      },
      expression: "schedule.timeZone"
    }
  })], 1)], 1), _c(VAlert, {
    staticClass: "mt-4 mb-0 trigger-summary tinted-alert tinted-alert--accent",
    attrs: {
      "color": _vm.color,
      "text": "",
      "dense": "",
      "data-cy": "trigger_summary"
    }
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.summaryText))]), _vm.cron ? _c('span', {
    staticClass: "trigger-cron mx-2",
    attrs: {
      "data-cy": "trigger_cron"
    }
  }, [_vm._v(_vm._s(_vm.cron))]) : _vm._e(), _vm.nextRunText ? _c('span', {
    staticClass: "trigger-next-run"
  }, [_vm._v("· " + _vm._s(_vm.nextRunText))]) : _vm._e()]), _vm.templateContext ? _c(VAlert, {
    staticClass: "mt-4 mb-0 tinted-alert",
    attrs: {
      "icon": "fal fa-info-circle",
      "text": "",
      "dense": "",
      "outlined": "",
      "data-cy": "trigger_spread_info"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.spreadInfoText) + "\n      ")]) : _vm._e()]], 2), !_vm.formIsValid ? _c(VAlert, {
    staticClass: "mt-6 mb-0 tinted-alert",
    attrs: {
      "type": "warning",
      "text": "",
      "dense": "",
      "data-cy": "trigger_invalid"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.t('invalid')) + "\n  ")]) : _vm._e(), _c(VDivider, {
    staticClass: "my-4"
  }), _c('p', {
    staticClass: "card-description mb-0",
    attrs: {
      "data-cy": "trigger_result"
    }
  }, [_c('span', {
    staticClass: "text-bold text-uppercase mr-2"
  }, [_vm._v(_vm._s(_vm.t('result')))]), _c('span', {
    attrs: {
      "data-cy": "trigger_result_text"
    }
  }, [_vm._v(_vm._s(_vm.resultText))])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };